import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { ModelEditDialogComponent } from '../../modeller/model-edit-dialog/model-edit-dialog.component';
import { RabatKampagneDto } from '../../../../api/models/OK/Egis/Service/Models/DTO/rabat-kampagne-dto';
import { RabatKampagneService } from '../../../../api/services/rabat-kampagne.service';
import { CreateRabatKampagneDto } from '../../../../api/models/OK/Egis/Service/Models/Request/create-rabat-kampagne-dto';
import { ErrorHandlerService } from '../../../../services/error-handler.service';
import { LoaderService } from '../../../../services/loader.service';

@Component({
    selector: 'app-rabatkampagner-edit-dialog',
    templateUrl: './rabatkampagner-edit-dialog.component.html',
    styleUrls: ['./rabatkampagner-edit-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RabatkampagnerEditDialogComponent implements OnInit {
  form: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private service: RabatKampagneService,
    private errorHandler: ErrorHandlerService,
    private loader: LoaderService,
    public dialogRef: MatDialogRef<ModelEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public rabatkampagne: RabatKampagneDto
  ) {
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      name: [this.rabatkampagne.name, [Validators.required]],
      validFrom: [this.rabatkampagne.validFrom, [Validators.required]],
      validTo: [this.rabatkampagne.validTo],
      rabatKontant: [this.rabatkampagne.kontant, [Validators.min(1)]],
      rabatProcent: [this.rabatkampagne.procent, [Validators.required, Validators.min(1), Validators.max(100)]],
      rabatTekst: [this.rabatkampagne.tekst, [Validators.maxLength(20)]],
      rabatSplit: [this.rabatkampagne.partnerShare == null ? -1 : this.rabatkampagne.partnerShare, [Validators.required]],
      engangsRabat: [this.rabatkampagne.isEngangs]
    });
  }

  async update() {
    if (!this.form.valid) {
      return;
    }

    const data: CreateRabatKampagneDto = {
      isEngangs: this.form.value.engangsRabat ?? false,
      kontant: this.form.value.rabatKontant,
      name: this.form.value.name,
      partnerShare: (this.form.value.rabatSplit === -1) ? null : this.form.value.rabatSplit,
      procent: this.form.value.rabatProcent,
      tekst: this.form.value.rabatTekst,
      validFrom: new Date(this.form.value.validFrom).toOkDateString(),
      validTo: this.form.value.validTo ? new Date(this.form.value.validTo).toOkDateString() : null
    };

    if (this.rabatkampagne.id) {
      this.loader.show();
      await this.service
        .updateRabatKampagne({
          rabatKampagneId: this.rabatkampagne.id,
          caller: EGIS_SERVICE_CALLER,
          body: data
        })
        .toPromise()
        .then((response) => {
          this.dialogRef.close(response);
        })
        .catch((error) => {
          this.errorHandler.HandleError(error);
        })
        .finally(() => {
          this.loader.hide();
        });
    } else {
      this.loader.show();
      await this.service.createRabatkampagne({ caller: EGIS_SERVICE_CALLER, body: data })
        .toPromise()
        .then((response) => {
          this.dialogRef.close(response);
        })
        .catch((error) => {
          this.errorHandler.HandleError(error);
        })
        .finally(() => {
          this.loader.hide();
        });
    }
  }
}
